import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { auth } from './firebase';
import { collection, doc, setDoc } from 'firebase/firestore';
import './RegisterPage.css';

const db = getFirestore();

const RegisterPage = () => {
  const [nickname, setNickname] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Validate nickname is not empty
    if (!nickname.trim()) {
      setError('Please enter your nickname');
      return;
    }

    // Construct email - add @hohopost.com only if not already an email
    const email = nickname.includes('@') ? nickname.toLowerCase() : `${nickname.toLowerCase()}@hohopost.com`;

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Create a tree for the user
      const treeId = user.uid;
      await setDoc(doc(collection(db, 'trees'), treeId), {
        userId: user.uid,
        treeName: `${name}'s Christmas Tree`,
        createdAt: new Date(),
      });

      setSuccess('Account created successfully! Share your tree link with friends!');
      navigate(`/tree/${treeId}`);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="christmas-register-page">
      <div className="lights-container">
        <video
          className="christmas-lights-video"
          autoPlay
          loop
          muted
          playsInline
          src={`${process.env.PUBLIC_URL}/christmas_lights.mp4`}
        >
          <source src={`${process.env.PUBLIC_URL}/christmas_lights.mp4`} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <header className="christmas-header">
      </header>

      <div className="register-card">
        <h2 className="register-title">Sign Up</h2>
        <form onSubmit={handleRegister}>
          <input
            type="text"
            placeholder="Your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="register-input"
            required
          />
          <input
            type="text"
            placeholder="Nickname"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            className="register-input"
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="register-input"
            required
          />
          <button type="submit" className="register-button">
            🎄 Register
          </button>
        </form>
        {error && <p className="error-message">{error}</p>}
        {success && <p className="success-message">{success}</p>}
      </div>
    </div>
  );
};

export default RegisterPage;